import React from 'react';
import { RichTextPageType } from '../../../lib/api/custom-page.types';
import { RichTextPageWrapper } from '../RichTextWrapper/RichTextPageWrapper';

export const RichTextCustomPage: React.FunctionComponent<RichTextPageType> = (props: RichTextPageType): JSX.Element | null => {
  if (props) return <RichTextPageWrapper {...props} />;
  return null;
};
